<div class="footer">
  <p [translate]="'footer'">This is your footer</p>
</div>
